import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';

import * as moment from 'moment';

import { default as AdvertPeriodPickerUtil, PickerProps } from '../utils/period_picker/AdvertPeriodPicker'
import { StartEnd } from '../utils/period_picker/PeriodPicker'

import * as PeriodEventEmitter from '../utils/period_picker/PeriodEventEmitter'
import IsSameMoment from '../utils/IsSameMoment'
import { FocusedInputShape, OrientationShape } from 'react-dates';


declare var $: any;

type Props = PickerProps & {
  startDateSelector: string
  endDateSelector: string
  orientation?: OrientationShape
  numberOfMonths?: number
}

type State = StartEnd & {
  focusedInput: FocusedInputShape
}
export default class AdvertPeriodPicker extends React.Component<Props, State> {
  subscriptionToken: string
  constructor(props, context) {
    super(props, context)
    this.state = {
      startDate: this.props.startDate !== null ? moment(this.props.startDate, "DD-MM-YYYY") : null,
      endDate:   this.props.endDate   !== null ? moment(this.props.endDate,   "DD-MM-YYYY") : null,
      focusedInput: null,
    }
  }

  componentWillMount() {
    this.subscriptionToken = PeriodEventEmitter.subscribe((payload: PeriodEventEmitter.EventPayload) => {
      if (!IsSameMoment(this.state.startDate, payload.start_date) || !IsSameMoment(this.state.endDate, payload.end_date)) {
        this.setState({ startDate: payload.start_date, endDate: payload.end_date})
      }
    })
  }

  componentWillUnmount() {
    PeriodEventEmitter.unsubscribe(this.subscriptionToken)
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.startDateSelector) {
      $(this.props.startDateSelector).val(this.state.startDate ? this.state.startDate.format("DD-MM-YYYY") : '')
    }
    if (this.props.endDateSelector) {
      $(this.props.endDateSelector).val(this.state.endDate ? this.state.endDate.format("DD-MM-YYYY") : '')
    }
  }

  onDatesChange(range: StartEnd) {
    this.setState({ ...range  })
  }

  render() {
    return (
      <AdvertPeriodPickerUtil
        advert_id={this.props.advert_id}
        prefix={this.props.prefix}
        onDatesChange={(range: StartEnd) => this.onDatesChange(range)}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onFocusChange={(fi) => this.setState({focusedInput: fi})}
        focusedInput={this.state.focusedInput}
        orientation={this.props.orientation}
        numberOfMonths={this.props.numberOfMonths}
        close={() => null}
      />
    )
  }
}
